import { createSelector } from "reselect"

const dataDocumentManagement = state => state.formulaireReducer.dataDocumentManagement
//******************************************************************************
//***************************** Selectors Documents ****************************
//******************************************************************************

//***************************** ACTUALITY *******************************
export const selectActualityList = createSelector(
  [dataDocumentManagement],
  select => select?.actualityList
)
export const selectActualitySelect = createSelector(
  [dataDocumentManagement],
  select => select?.actualitySelect
)
//**************************** GOVERNANCE *******************************
export const selectGovernanceList = createSelector(
  [dataDocumentManagement],
  select => select?.governanceList
)
export const selectGovernanceSelect = createSelector(
  [dataDocumentManagement],
  select => select?.governanceSelect
)
//************************ DOCUMENT_SOLLICITE ***************************
export const selectDocumentList = createSelector(
  [dataDocumentManagement],
  select => select?.documentList
)

export const selectDocumentsWaitingValidation = createSelector(
  [dataDocumentManagement],
  select => select?.documentsWaitingValidation
)
//************************* CONTROL_ARCHIVED ****************************
export const selectControlPlanWithArchivedControls = createSelector(
  [dataDocumentManagement],
  select => select?.controlPlanWithArchivedControls
)
//************************* DOCUMENTS ASSOCIATE RESPONSE CONTROL ****************************
export const selectDocumentsAssociateResponseControl = createSelector(
  [dataDocumentManagement],
  select => select?.documentsAssociateResponseControl
)
